import React, { Component } from 'react';
import { Divider, Switch, Button, NumericInput } from '@blueprintjs/core';
import SideMenuWrapper from '../Components/SideMenuWrapper';

export default class PCIPLimit extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      PCLimit: true,
      PCLimitCount: 1,
      IPLimit: true,
      IPLimitCount: 10,
    };

    this.handleChange = (Name) => (Value) => {
      if (typeof this.state[Name] === 'boolean')
        this.setState({ [Name]: !this.state[Name] });
      else if (Value.target) this.setState({ [Name]: Value.target.value });
      else this.setState({ [Name]: Value });
    };
  }

  render() {
    const SwitchOnOff = { innerLabelChecked: 'on', innerLabel: 'off' };

    return (
      <SideMenuWrapper>
        <h3
          className="display-4 font-italic mb-4"
          style={{ fontSize: '1.5rem' }}
        >
          PC/IP Limit
        </h3>

        <Divider />

        <table className="bp3-html-table bp3-html-table-bordered bp3-interactive html-table-row-border">
          <tbody>
            <tr>
              <td style={{ minWidth: '150px' }}>PC Limit</td>
              <td>
                <Switch
                  checked={this.state.PCLimit}
                  {...SwitchOnOff}
                  onChange={this.handleChange('PCLimit')}
                />
              </td>
            </tr>

            <tr>
              <td>PC Limit Count</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.PCLimit}
                  style={{ width: '120px' }}
                  value={this.state.PCLimitCount}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('PCLimitCount')}
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td>IP Limit</td>
              <td>
                <Switch
                  checked={this.state.IPLimit}
                  {...SwitchOnOff}
                  onChange={this.handleChange('IPLimit')}
                />
              </td>
            </tr>

            <tr>
              <td>IP Limit Count</td>
              <td style={{ width: '240px' }}>
                <NumericInput
                  disabled={!this.state.IPLimit}
                  style={{ width: '120px' }}
                  value={this.state.IPLimitCount}
                  placeholder="Type a limit..."
                  onValueChange={this.handleChange('IPLimitCount')}
                  className="mb-4"
                  min={0}
                />
              </td>
            </tr>

            <tr>
              <td></td>
              <td>
                <Button className="mt-2" icon="floppy-disk" text="Save" />
              </td>
            </tr>
          </tbody>
        </table>
      </SideMenuWrapper>
    );
  }
}
